/* eslint-disable max-len */
import LandingPage from '@/containers/Desktop/LandingPage';
// import CMSComponent from './CMS';
import {
  addAllPoints,
  adjustAllPassengers,
  adjustSeatClass,
} from '@/slices/area/slices/searchFlightFormSlice';
import { TSelectedDate } from '@/slices/calendar';
import { setSelectedDate } from '@/slices/calendar/calendarSlice';
import {
  removeFlight,
  removeReturnFlight,
} from '@/slices/selectedFlight/slices/selectedFlightSlice';
import { style } from '@/styles/globals';
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import { getParamsFlightMapping } from '@/utils/paramsMapping';
import { pr } from '@/utils/pxToRem';
import { Box, Stack } from '@mui/material';
import { styled } from '@mui/system';
import { getDate, getMonth } from 'date-fns';
import { useRouter } from 'next/router';
import React from 'react';
import CompanySeoBreadcrumbs from '../desktop/CompanySeoBreadcrumbs';
import HeaderBar from '../desktop/HeaderBar';
import SectionManager from './SectionManager';
import BannerDiscount from '@/components/BannerDiscount';
import BreadcrumbsSeo from '../BreadcrumbsSeo';
import { slugify } from '@/utils/stringConvert';

function CompanyPage({ branchPage, countSeoResult, headerTabs }: { [key: string]: any }) {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const {
    passenger: statePassenger,
    seatClass: stateSeatClass,
    startPointHome: startPoint,
    toPointHome: toPoint,
  } = useAppSelector((state) => state.searchFlightForm);

  const routeName = `từ ${startPoint?.location} đi ${toPoint?.location}`;
  const routeName2 = `${startPoint?.location} - ${toPoint?.location}`;
  const routeCode = `${startPoint?.airports[0]?.airportCode}-${toPoint?.airports[0]?.airportCode}`;
  const routeCodeReturn = `${toPoint?.airports[0]?.airportCode}-${startPoint?.airports[0]?.airportCode}`;

  const wrapperRef = React.useRef(null);
  const selectedDate = {
    depart: new Date(),
    return: null,
  };

  const onSearchFlight = (date: TSelectedDate) => {
    const tmpStartPoint = startPoint;
    const tmpToPoint = toPoint;
    const tmpSelectedDate = date || selectedDate;

    const tmpPassenger = statePassenger;
    const tmpSeatClass = stateSeatClass;
    if (
      !tmpStartPoint
      || !tmpToPoint
      || !tmpSelectedDate
      || !tmpPassenger
      || !tmpSeatClass
    ) {
      return;
    }
    dispatch(removeFlight());
    dispatch(removeReturnFlight());

    dispatch(
      addAllPoints([
        {
          data: tmpStartPoint,
          type: 'from',
        },
        {
          data: tmpToPoint,
          type: 'to',
        },
      ]),
    );
    dispatch(setSelectedDate({ dateObj: JSON.stringify(tmpSelectedDate) }));
    dispatch(adjustAllPassengers(tmpPassenger));
    dispatch(adjustSeatClass({ seatClass: tmpSeatClass }));

    const path = getParamsFlightMapping({
      tmpPassenger,
      tmpSeatClass,
      tmpSelectedDate,
      tmpToPoint,
      tmpStartPoint,
    });
    router.push(path);
  };
  // const routeId = startPoint ? `${startPoint.id}.${currToPoint.id}` : currToPoint.id;

  const formatDate = ` ngày ${getDate(new Date())} tháng ${
    getMonth(new Date()) + 1
  }`;
  return (
    <Wrapper
      ref={wrapperRef}
      // onScroll={onScroll}
    >
      <HeaderBar />
      <LandingPage
        title={`Đặt mua vé máy bay ${branchPage?.name} giá rẻ${formatDate}`}
        // filterAirline={[branchPage?.type]}
      />
      <Stack
        spacing={pr`24px`}
        sx={{
          padding: {
            xs: '24px 24px',
            md: '24px 24px',
            lg: '24px 144px',
          },
          background: `${style.color.white2} !important`,
        }}
      >
        <BreadcrumbsSeo
          sx={{
            background: '#EFF2F5',
          }}
          breadcrumbs={[
            {
              title: 'Goyolo.com',
              url: '/',
            },
            {
              title: 'Vé máy bay giá rẻ',
              url: '/vn/ve-may-bay.vi',
            },
            {
              title: `Vé máy bay ${branchPage?.name}`,
              url: `/vn/ve-may-bay/${slugify(branchPage?.name)}.vi`,
            },
          ]}
        />
        <BannerDiscount
          isDesktop
          isHiddenTitle
          sx={{
            marginBottom: '16px',
          }}
          vehicleType={headerTabs === 0 ? 'flight' : 'bus'}
        />
        <Box
          sx={{
            background: `${style.color.white2} !important`,
          }}
        >
          <SectionManager
            isDesktop
            routeCode={routeCode}
            routeCodeReturn={routeCodeReturn}
            startPointHome={startPoint}
            toPointHome={toPoint}
            company={branchPage?.name}
            companySlug={branchPage?.slug}
            branchPage={branchPage}
            sxWrapper={{
              px: pr`16px`,
              pt: pr`32px`,
            }}
            routeName={routeName}
            routeName2={routeName2}
            onSearchFlight={onSearchFlight}
            countSeoResult={countSeoResult}
          />
        </Box>
      </Stack>
    </Wrapper>
  );
}

// const StyledWrapper = styled('div')({
//   background: '#FFFFFF',
// });

const Wrapper = styled('div')`
  height: 100vh;
  overflow: scroll;
  .category-container {
    padding: 16px 0px;
  }

  .category-item {
    margin-right: 8px;
  }
`;

export default React.memo(CompanyPage);
